require("core-js/modules/es.array.find");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.split");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.qaDetail = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var _default = {
    name: 'XiazengQaDetail',
    data: function data() {
      var ossHostPond = this.$config.base.ossHostPond;
      return {
        ossPondHost: ossHostPond,
        info: {},
        showMediaModal: false,
        showPreviewImg: false,
        currentIndex: 0,
        picUrl: '',
        videoUrl: ''
      };
    },
    created: function created() {
      var vm = this; // 从路由 query 获取详情数据（JSON 字符串）

      var infoStr = vm.$route.query.info;

      if (infoStr) {
        try {
          var info = JSON.parse(infoStr);

          if (info && info.submitTime) {
            var parts = info.submitTime.split(' ');
            info.submitDate = parts[0] || '';
            info.submitHour = parts[1] || '';
          }

          vm.info = info;
          vm.picUrl = vm.getUrl(info.testPic);
          vm.videoUrl = vm.getUrl(info.testVideo);
        } catch (e) {
          vm.info = {};
        }
      }
    },
    methods: {
      // testPic/testVideo 兼容字符串或数组格式，取第一个有效值
      getUrl: function getUrl(val) {
        if (!val) return '';

        if (Array.isArray(val)) {
          return val.find(function (item) {
            return !!item;
          }) || '';
        }

        return val;
      },
      openMediaModal: function openMediaModal() {
        this.showMediaModal = true;
        this.showPreviewImg = false;
        this.currentIndex = 0;
      },
      closeMediaModal: function closeMediaModal() {
        this.showMediaModal = false;
        this.showPreviewImg = false;
        var video = this.$refs.mediaVideo;

        if (video) {
          video.pause();
        }
      },
      changeMediaIndex: function changeMediaIndex(index) {
        this.currentIndex = index;
      }
    }
  };
  _exports.default = _default;
});